module.exports = __webpack_public_path__ + "static/media/check-green.accfd534.svg";